const FINANCES_INVOICES_BASE = '/finances/invoices';

/** Canonical client routes for the Finances module. */
export const FINANCES_PATHS = {
  invoices: FINANCES_INVOICES_BASE,
  invoicesNew: `${FINANCES_INVOICES_BASE}/new`,
  tripEdit: (
    tripId: string | number,
    invoiceId?: string | number,
    tramsAccountId?: string | number,
  ) => {
    const base = `${FINANCES_INVOICES_BASE}/trips/${encodeURIComponent(String(tripId))}/edit`;
    const params = new URLSearchParams();
    if (invoiceId != null) params.set("invoiceId", String(invoiceId));
    if (tramsAccountId != null) params.set("tramsAccountId", String(tramsAccountId));
    const qs = params.toString();
    return qs ? `${base}?${qs}` : base;
  },
  invoiceEdit: (id: string | number) =>
    `${FINANCES_INVOICES_BASE}/${encodeURIComponent(String(id))}/edit`,
  snapshots: '/finances/snapshot',
  statements: '/finances/statements',
  unclaimed: '/finances/unclaimed-commissions',
} as const;

/** Wouter `path` for trip edit — must be registered before FINANCES_INVOICES_EDIT_ROUTE. */
export const FINANCES_TRIP_EDIT_ROUTE = `${FINANCES_INVOICES_BASE}/trips/:tripId/edit`;

/** Wouter `path` for invoice edit — derived from invoices base + `:id/edit`. */
export const FINANCES_INVOICES_EDIT_ROUTE = `${FINANCES_INVOICES_BASE}/:id/edit`;

/**
 * Finances Route `path` props in App.tsx — must stay synchronized with FINANCES_PATHS.
 * Param routes (e.g. FINANCES_INVOICES_EDIT_ROUTE) are listed separately.
 */
export const FINANCES_APP_ROUTE_PATHS = [
  FINANCES_PATHS.invoicesNew,
  FINANCES_TRIP_EDIT_ROUTE,
  FINANCES_INVOICES_EDIT_ROUTE,
  FINANCES_PATHS.invoices,
  FINANCES_PATHS.statements,
  FINANCES_PATHS.snapshots,
  FINANCES_PATHS.unclaimed,
] as const;

/** Paths that highlight the Finances item in the primary sidebar. */
export const FINANCES_NAV_MATCH_PATHS = [
  FINANCES_PATHS.invoices,
  FINANCES_PATHS.snapshots,
  FINANCES_PATHS.statements,
  FINANCES_PATHS.unclaimed,
  // Legacy redirects (bookmarks)
  '/invoicing',
  '/reports',
  '/finances/snapshots',
  '/statements',
  '/unclaimed',
] as const;
